var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',{staticClass:"item"},_vm._l((5),function(item){return _c('tr',{key:item},[_c('td'),_vm._l((6),function(itemCell){return _c('td',{key:itemCell},[_c('v-skeleton-loader',{staticClass:"text",attrs:{"type":"text"}})],1)}),_c('td',[_c('v-skeleton-loader',{staticClass:"avatar",attrs:{"type":"avatar"}})],1)],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }